import React from 'react';

const SelectedFilterBadges = ({
    t,
    selectedSkillNames,
    selectedTextTypeNames,
    selectedDimCompNames,
    selectedElementNames,
    toggleFilterItem,
    clearAllFilters,
    totalSelectedFilters
}) => {
    if (!totalSelectedFilters || totalSelectedFilters === 0) return null;

    return (
        <div className="selected-skills-container mt-3 pt-2 d-flex flex-column" style={{ gap: '10px', direction: 'rtl', borderTop: '1px dashed rgba(146, 39, 143, 0.2)' }}>
            <div className="d-flex align-items-center justify-content-between">
                <span className="small text-muted font-weight-bold" style={{ fontSize: '13px', color: '#475569' }}>
                    <i className="fad fa-filter text-primary ml-1"></i> {t("SelectedFilters") || "الفلاتر المختارة:"}
                </span>
                <button
                    type="button"
                    onClick={clearAllFilters}
                    className="btn btn-sm btn-outline-danger rounded-pill px-3 py-1 font-weight-bold"
                    style={{ fontSize: '12px', width: 'auto', flexShrink: 0 }}
                >
                    <i className="fas fa-trash-alt ml-1"></i> {t("ClearFilter") || "إلغاء التصفية"}
                </button>
            </div>

            <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                {/* Skill Group Badges */}
                {selectedSkillNames?.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px', maxWidth: '100%' }}>
                        <span className="small font-weight-bold text-muted ml-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                            {t("Skills") || "المهارات"}:
                        </span>
                        {selectedSkillNames.map(name => (
                            <span key={`badge-skill-${name}`} className="badge rounded-pill d-inline-flex align-items-center px-3 py-2" style={{ background: '#fffbeb', color: '#92400e', fontSize: '12px', border: '1px solid #fde68a', gap: '8px', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                <i className="fad fa-lightbulb text-warning flex-shrink-0"></i> {name}
                                <i className="fas fa-times-circle text-danger flex-shrink-0" onClick={() => toggleFilterItem('skill', name)} style={{ cursor: 'pointer', fontSize: '14px' }}></i>
                            </span>
                        ))}
                    </div>
                )}

                {/* TextType Group Badges */}
                {selectedTextTypeNames?.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px', maxWidth: '100%' }}>
                        <span className="small font-weight-bold text-muted ml-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                            {t("TextTypes") || "أنواع النصوص"}:
                        </span>
                        {selectedTextTypeNames.map(name => (
                            <span key={`badge-textType-${name}`} className="badge rounded-pill d-inline-flex align-items-center px-3 py-2" style={{ background: '#f0f9ff', color: '#075985', fontSize: '12px', border: '1px solid #bae6fd', gap: '8px', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                <i className="fad fa-file-alt text-info flex-shrink-0"></i> {name}
                                <i className="fas fa-times-circle text-danger flex-shrink-0" onClick={() => toggleFilterItem('textType', name)} style={{ cursor: 'pointer', fontSize: '14px' }}></i>
                            </span>
                        ))}
                    </div>
                )}

                {/* DimensionComponent Group Badges */}
                {selectedDimCompNames?.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px', maxWidth: '100%' }}>
                        <span className="small font-weight-bold text-muted ml-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                            {t("DimensionComponents") || "مكونات الأبعاد"}:
                        </span>
                        {selectedDimCompNames.map(name => (
                            <span key={`badge-dimComp-${name}`} className="badge rounded-pill d-inline-flex align-items-center px-3 py-2" style={{ background: '#ecfdf5', color: '#065f46', fontSize: '12px', border: '1px solid #a7f3d0', gap: '8px', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                <i className="fad fa-layer-group text-success flex-shrink-0"></i> {name}
                                <i className="fas fa-times-circle text-danger flex-shrink-0" onClick={() => toggleFilterItem('dimComp', name)} style={{ cursor: 'pointer', fontSize: '14px' }}></i>
                            </span>
                        ))}
                    </div>
                )}

                {/* Element Group Badges */}
                {selectedElementNames?.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px', maxWidth: '100%' }}>
                        <span className="small font-weight-bold text-muted ml-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                            {t("Elements") || "العناصر"}:
                        </span>
                        {selectedElementNames.map(name => (
                            <span key={`badge-element-${name}`} className="badge rounded-pill d-inline-flex align-items-center px-3 py-2" style={{ background: '#fef2f2', color: '#991b1b', fontSize: '12px', border: '1px solid #fecaca', gap: '8px', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                <i className="fad fa-cube text-danger flex-shrink-0"></i> {name}
                                <i className="fas fa-times-circle text-danger flex-shrink-0" onClick={() => toggleFilterItem('element', name)} style={{ cursor: 'pointer', fontSize: '14px' }}></i>
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectedFilterBadges;
